import cmpStatus from "../cmp-status";
import {subscribe} from "../util/js-event";
import {EGDPREvent, IPrivacityEvent} from "./window/impl/g-d-p-r-manager";
import AnalyticManager from "../analytic/analytic-manager";
import {COMPUTED_LABEL_VALOR} from "../analytic/event";
import {EAction, ELabel} from "../analytic/event-definition";
import cmp, {site} from "../context/context";
import {UIEvent} from "./u-i-event";
import {TEvent, TEventSubtype} from "services-comun-meteored/modules/services/cmp/web/events";
import {EPropVendLayerEvent, IAcceptAllEvent, ISaveEvent} from "./window/impl/c-m-p-manager";
import {
    EInsistWindowEvent,
    IInsistWindowAcceptAllEvent,
    IInsistWindowCloseEvent
} from "./window/impl/insist-window-manager";
import Client from "../client/client";
import {CMPWindow} from "./window/c-m-p-window";
import {ECMPWindow} from "./window/interface";
import {ApareceGlobal} from "../session/aparece-global";

type TCMPLayer = 'main'|'vendors';
export type UICallback = (event: EUIEvent) => void;

export enum EUIEvent {
    CONFIGURE       = 'configured',
}

// Suscripciones a eventos
subscribe(EGDPREvent.ACEPTAR, () => {
    cmp().acceptAll();

    // Cierra la ventana de GDPR
    UIManager.closeWindows([ECMPWindow.GDPR]);

    UIManager.GDPR_OPENED = false;

    // Lanzamos el evento de aceptación
    const event = UIEvent.create(TEvent.ACEPTAR_TODO);
    event.register();
    event.notify();

    // Lanzamos el evento de finalización
    const event2 = UIEvent.create(TEvent.FINALIZAR);
    event2.register();
    event2.notify();

    // Lanzamos evento analítico
    AnalyticManager().register({
        action: EAction.GDPR,
        label: ELabel.ACEPTAR
    });

    // Lanzamos eventos analítico
    AnalyticManager().register({
        action: EAction.GDPR,
        label: ELabel.ACEPTAR_GLOBAL
    });

    // Lanzamos evento analítico
    AnalyticManager().register({
        action: EAction.GDPR,
        label: COMPUTED_LABEL_VALOR()
    });
});

subscribe(EGDPREvent.CONFIGURAR, async () => {
    // Quitamos el proxy
    await cmp().unproxy();

    // Callback de configuración del CMP
    const callback: UICallback = (event: EUIEvent) => {
        if (event == EUIEvent.CONFIGURE) {
            // Cierra la ventana de GDPR
            UIManager.closeWindows([ECMPWindow.GDPR]);

            UIManager.GDPR_OPENED = false;
        }
    }

    // Abrimos la ventana de configuración del CMP
    UIManager.openCMP("main", [callback]);

    // Lanzamos el evento de configuración
    const event = UIEvent.create(TEvent.CONFIGURAR);
    event.register();
    event.notify();

    // Lanzamos evento analítico
    AnalyticManager().register({
        action: EAction.GDPR,
        label: ELabel.CONFIGURACION
    });
});

subscribe(EGDPREvent.RECHAZAR, () => {
    // Si no hay insist mode, rechazamos directamente o
    // Si ya está logado/suscrito, rechazamos directamente
    if (!site.insistModeConfig()?.e || Client().premium) {
        cmp().rejectAll();

        // Cierra la ventana de GDPR
        UIManager.closeWindows([ECMPWindow.GDPR]);

        UIManager.GDPR_OPENED = false;

        // Lanzamos evento analítico
        AnalyticManager().register({
            action: EAction.GDPR,
            label: ELabel.RECHAZAR_GLOBAL
        });

        // Lanzamos el evento de finalización
        const event = UIEvent.create(TEvent.FINALIZAR);
        event.register();
        event.notify();
    } else {
        // Comprobamos si hay Direct Approve
        if (site.insistModeConfig()?.da) {
            // Lanzamos el evento de aceptación
            const event = UIEvent.create(TEvent.PLATFORM_APPROVE, TEventSubtype.ANY);
            event.register();
            event.notify();

            // Lanzamos evento analítico
            AnalyticManager().register({
                action: EAction.INSIST,
                label: ELabel.REGISTRARSE
            });
        } else {
            // Abrimos la capa de insistencia
            UIManager.openInsistWindow();

            // Cierra la ventana de GDPR
            UIManager.closeWindows([ECMPWindow.GDPR]);

            UIManager.GDPR_OPENED = false;
        }
    }

    // Lanzamos el evento de rechazo
    const event = UIEvent.create(TEvent.RECHAZAR_TODO);
    event.register();
    event.notify();

    // Lanzamos evento analítico
    AnalyticManager().register({
        action: EAction.GDPR,
        label: ELabel.RECHAZAR
    });
});

subscribe(EGDPREvent.PRIVACIDAD, (data: IPrivacityEvent) => {
    setTimeout(() => {
        window.location.href = data.url_privacidad;
    }, 150);
});

subscribe(EGDPREvent.VENDORS, async () => {
    // Quitamos el proxy
    await cmp().unproxy();

    // Callback de configuración del CMP
    const callback: UICallback = (event: EUIEvent) => {
        if (event == EUIEvent.CONFIGURE) {
            // Cierra la ventana de GDPR
            UIManager.closeWindows([ECMPWindow.GDPR]);

            UIManager.GDPR_OPENED = false;
        }
    }

    // Abrimos la ventana de configuración del CMP
    UIManager.openCMP("vendors", [callback]);

    // Lanzamos evento analítico
    AnalyticManager().register({
        action: EAction.GDPR,
        label: ELabel.SOCIOS
    });
});

subscribe(EPropVendLayerEvent.ACEPTAR_TODO, (data: IAcceptAllEvent) => {
    // Aceptar todos los consentimientos y guardar
    cmp().acceptAll();

    // Cierra la ventana del Cmp
    UIManager.closeWindows([ECMPWindow.CONFIGURATION]);

    // Ejecuta los callbacks
    data.callbacks.forEach(callback => {
        callback(EUIEvent.CONFIGURE);
    });

    // Registrar evento
    const event = UIEvent.create(TEvent.ACEPTAR_TODO);
    event.register();
    event.notify();

    // Lanzamos el evento de finalización
    const event2 = UIEvent.create(TEvent.FINALIZAR);
    event2.register();
    event2.notify();

    // Lanzamos evento analítico
    AnalyticManager().register({
        action: EAction.CONFIGURAR,
        label: ELabel.ACEPTAR_TODO_GUARDAR
    });

    // Lanzamos evento analítico
    AnalyticManager().register({
        action: EAction.CONFIGURAR,
        label: ELabel.ACEPTAR_GLOBAL
    });
});

subscribe(EPropVendLayerEvent.GUARDAR, (data: ISaveEvent) => {
    /*
     * Si todos los vendors están aceptados
     * o no hay insistModeConfig
     * o hay insistModeConfig y el usuario es premium
     * ,se guarda la configuración de usuario.
     */
    if (data.allSelected || !site.insistModeConfig()?.e || (site.insistModeConfig()?.e && Client().premium)) {
        // Guarda la configuración de usuario
        cmp().saveAndAcceptConfiguration();

        // Cierra la ventana del CMP
        UIManager.closeWindows([ECMPWindow.CONFIGURATION]);

        // Ejecuta los callbacks
        data.callbacks.forEach(callback => {
            callback(EUIEvent.CONFIGURE);
        });

        // Lanzamos el evento de finalización
        const event = UIEvent.create(TEvent.FINALIZAR);
        event.register();
        event.notify();

        // Lanzamos evento analítico
        AnalyticManager().register({
            action: EAction.CONFIGURAR,
            label: data.allSelected ? ELabel.ACEPTAR_GLOBAL : ELabel.RECHAZAR_GLOBAL
        });
    } else {
        // Cierra la ventana del CMP
        UIManager.closeWindows([ECMPWindow.CONFIGURATION]);

        // Comprobamos si hay Direct Approve
        if (site.insistModeConfig()?.da) {
            // Lanzamos el evento de aceptación
            const event = UIEvent.create(TEvent.PLATFORM_APPROVE);
            event.register();
            event.notify();

            // Lanzamos evento analítico
            AnalyticManager().register({
                action: EAction.INSIST,
                label: ELabel.REGISTRARSE
            });
        } else {
            const isGPDROpen = UIManager.GDPR_OPENED;

            // Ejecuta los callbacks
            data.callbacks.forEach(callback => {
                callback(EUIEvent.CONFIGURE);
            });

            // Abrimos la capa de insistencia
            UIManager.openInsistWindow([], isGPDROpen);
        }
    }

    // Lanzamos evento analítico
    AnalyticManager().register({
        action: EAction.CONFIGURAR,
        label: ELabel.GUARDAR_CERRAR_HABILITADO
    });

    // Registrar evento
    const event = UIEvent.create(TEvent.GUARDAR,
        data.allSelected
            ? TEventSubtype.TODO_ACEPTADO
            : (data.allRejected
                ? TEventSubtype.TODO_RECHAZADO
                : TEventSubtype.CONFIGURADO)
    );
    event.register();
    event.notify();
});

subscribe(EPropVendLayerEvent.CLOSE, () => {

    // Cerramos la ventana
    UIManager.closeWindows([ECMPWindow.CONFIGURATION]);

    /*
     * Si no está abierta la ventana de GDPR
     * es porque se ha abierto directamente esta segunda capa,
     * por tanto, se puede cerrar sin más y finalizar la
     * configuración.
     */
    if (!UIManager.GDPR_OPENED) {
        // Lanzamos el evento de finalización
        const event = UIEvent.create(TEvent.FINALIZAR);
        event.register();
        event.notify();
    }

    // Lanzamos evento analítico
    AnalyticManager().register({
        action: EAction.CONFIGURAR,
        label: ELabel.CERRAR
    });
});

subscribe(EInsistWindowEvent.ACEPTAR, (data: IInsistWindowAcceptAllEvent) => {
    // Aceptar todos los consentimientos y guardar
    cmp().acceptAll();

    // Lanzamos el evento de aceptación
    const event = UIEvent.create(TEvent.ACEPTAR_TODO);
    event.register();
    event.notify();

    // Lanzamos el evento de finalización
    const event2 = UIEvent.create(TEvent.FINALIZAR);
    event2.register();
    event2.notify();

    UIManager.closeWindows([ECMPWindow.INSIST]);

    // Ejecuta los callbacks
    data.callbacks.forEach(callback => {
        callback(EUIEvent.CONFIGURE);
    });

    // Lanzamos evento analítico
    AnalyticManager().register({
        action: EAction.INSIST,
        label: ELabel.ACEPTO_Y_CAMBIO
    });

    // Lanzamos evento analítico
    AnalyticManager().register({
        action: EAction.INSIST,
        label: ELabel.ACEPTAR_GLOBAL
    });
});

subscribe(EInsistWindowEvent.PLATFORM_APPROVE_S, () => {

    // Lanzamos el evento de aceptación
    const event = UIEvent.create(TEvent.PLATFORM_APPROVE, TEventSubtype.REG_SUB);
    event.register();
    event.notify();

    // Lanzamos evento analítico
    AnalyticManager().register({
        action: EAction.INSIST,
        label: ELabel.REGISTRARSE
    });
});

subscribe(EInsistWindowEvent.PLATFORM_APPROVE_L, () => {

    // Lanzamos el evento de aceptación
    const event = UIEvent.create(TEvent.PLATFORM_APPROVE, TEventSubtype.LOGIN);
    event.register();
    event.notify();

    // Lanzamos evento analítico
    AnalyticManager().register({
        action: EAction.INSIST,
        label: ELabel.INICIA_SESION
    });
});

subscribe<IInsistWindowCloseEvent>(EInsistWindowEvent.CLOSE, () => {

    // Cierra la ventana de insistencia
    UIManager.closeWindows([ECMPWindow.INSIST]);

    // Abre GDPR
    UIManager.openGDPR();

    // Lanzamos evento analítico
    AnalyticManager().register({
        action: EAction.INSIST,
        label: ELabel.CERRAR
    });
});

class UIManager {

    public static CMP_WINDOWS: CMPWindow[] = [];

    public static GDPR_OPENED: boolean = false;

    public static openGDPR(): void {
        import(/* webpackChunkName: "gpdrManager",  */ "./window/impl/g-d-p-r-manager").then(async ({GDPRManager}) => {
            GDPRManager.instance().openGDPR();

            this.CMP_WINDOWS.push(GDPRManager.instance());

            // Registramos en el estado que el CMP se está mostrando en su primera capa
            cmpStatus.mainLayerDisplayed();

            this.GDPR_OPENED = true;
        });
    }


    public static openCMP(layer: TCMPLayer = "main", callbacks: UICallback[] = []): void {
        import(/* webpackChunkName: "cmpManager",  */ "./window/impl/c-m-p-manager").then(async ({CMPManager}) => {
            switch (layer) {
                case "main":
                    CMPManager.instance().openPurposes(callbacks);
                    this.CMP_WINDOWS.push(CMPManager.instance());
                    break;
                case "vendors":
                    CMPManager.instance().openVendors(callbacks);
                    this.CMP_WINDOWS.push(CMPManager.instance());
                    break;
            }


            if (ApareceGlobal.get().key !== '1') {
                AnalyticManager().register({
                    action: EAction.CONFIGURAR,
                    label: ELabel.APARECE_GLOBAL
                });
            }
        });
    }

    public static openInsistWindow(callbacks: UICallback[] = [], allowClose: boolean = true): void {
        import(/* webpackChunkName: "insistWindow",  */ "./window/impl/insist-window-manager").then(async ({InsistWindowManager}) => {
            InsistWindowManager.instance().openInsistWindow(callbacks, {
                allowClose
            });
            this.CMP_WINDOWS.push(InsistWindowManager.instance());
        });
    }

    public static closeWindows(windowIds?: ECMPWindow[], fnc?: Function): void {
        if (windowIds && windowIds.length) {
            windowIds.forEach(windowId => {
                const windowIndex = UIManager.CMP_WINDOWS.findIndex(v => v.id == windowId);

                if (fnc) {
                    fnc();
                } else if (windowIndex >= 0) {
                    UIManager.CMP_WINDOWS[windowIndex].close();
                }

                if (windowIndex >= 0) {
                    UIManager.CMP_WINDOWS.splice(windowIndex, 1)
                }
            });
        } else {
            UIManager.CMP_WINDOWS.forEach(window => {
                window.close();
            })
        }
    }

    public static cmpWindowDisplayed(): CMPWindow | undefined {
        if (this.CMP_WINDOWS.length > 0) {
            return this.CMP_WINDOWS[this.CMP_WINDOWS.length - 1];
        }
        return undefined;
    }
}

export {UIManager}
